<template>
    <div>
        <menu-bar></menu-bar>

        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">
                <ol class="breadcrumb noprint">
                    <li>
                        <a href="#/">
                            <i class="fa fa-home" aria-hidden="true"></i> INICIAL
                        </a>
                    </li>
                    <li class="active"> <i class="fa fa-suitcase" aria-hidden="true"></i> PACPON SEM ONU-MAC CADASTRADA</li>
                </ol>
                <div class="row">

                    <div class="col-md-12 noprint">
                        <br/>
                        <blockquote class="blockquote-reverse">
                            Total de pacpon sem onu-mac: <b>{{ contratos.length }}</b>
                        </blockquote>
                    </div>

                    <div class="col-md-12" style="margin-top: 20px">

                        <button class="btn-danger btn btn-xs noprint" type="button" @click="print()">
                            <i class="fa fa-print" aria-hidden="true"></i> IMPRIMIR
                        </button><br/><br/>

                        <table id="mytable" class="table table-bordred ">

                            <thead>
                            <tr>
                                <th>NOME</th>
                                <th style="text-align: center;width: 140px" class="noprint">AÇÕES</th>
                            </tr>
                            </thead>

                            <tbody>

                            <tr v-for="r in contratos" v-bind:key="r._id">
                                <td>
                                    <b>{{ r.nome }}</b><br/>
                                </td>
                                <td class="noprint text-center">
                                    <a :href="'#/caixa-pacpon/add/' + r._id" class="btn btn-primary btn-xs">
                                        ABRIR <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                                    </a>
                                </td>
                            </tr>

                            </tbody>

                        </table>

                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { CaixaPacPon } from "../../class/index";

export default {
    data() {
        return {
            contratos: [],
            user: null,
            nome: null
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
        this.loadSemVlam();
    },
    methods: {
        loadSemVlam() {
            CaixaPacPon.allSemOnuMac()
                .then(rows => (this.contratos = rows))
                .catch(err => console.log(err));
        },
        print() {
            window.print();
        }
    }
};
</script>
